import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { usePanelAuth } from "../../context/PanelAuthContext";
import logo from "../../assets/logo.png";

export default function PanelLogin() {
  const { login } = usePanelAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(form);
      navigate("/panel", { replace: true });
    } catch (err) {
      setError(err.friendlyMessage || "Could not log you in.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="pm-auth-shell">
      <Link to="/" className="pm-auth-shell__back pm-btn pm-btn--ghost pm-btn--sm">
        ← Back to home
      </Link>
      <motion.div className="pm-auth-card" initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
        <Link to="/" className="pm-auth-brand">
          <img src={logo} alt="Positive Moves" className="pm-brand-logo" />
        </Link>
        <h1>Panel login</h1>
        <p className="pm-auth-sub">Access is provided by the hiring admin — contact them if you don't have credentials.</p>

        <form onSubmit={handleSubmit} className="pm-auth-form">
          <div className="pm-field">
            <label>Email address</label>
            <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div className="pm-field">
            <label>Password</label>
            <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>
          {error && <div className="pm-form-error">{error}</div>}
          <button className="pm-btn pm-btn--primary pm-btn--lg" disabled={loading} type="submit">
            {loading ? "Logging in…" : "Log in"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}